import axios from 'axios'
import store from '../store/store'
import {Message} from 'view-design'
import router from '../router/index'

// 创建一个 axios 实例
const service = axios.create({
    withCredentials: true,
    baseURL: process.env.BASE_URL,
    timeout: 50000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {

        config.method = config.isGet ? 'GET' : 'POST'
        config.data = JSON.stringify(config.data);
        if(store.getters['admin/user']) {
            config.headers['APPLICATION-MEMBER'] = store.getters['admin/user'].token;
        }
        return config
    },
    error => {
        // 发送失败
        // console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        if(response.data.status == 0){
            Message.error(response.data.msg);

            if(response.data.code == 9999){
                // 需要登录了！
                store.dispatch('setUser', null);
                router.push({
                    name: 'Login'
                })
            }
        }
        return response.data
    },
    error => {
        // Message.error('系统错误！请联系管理员');
        if (error && error.response) {
            console.log(error.response)
        }
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/api/index.js